// taken from https://www.dolthub.com/blog/2024-03-20-dynamic-tailwind-themes/
import { BrandInterface, BrandThemeInterface, DefaultTheme } from "@swivl-mono/types";
import { createContext, useEffect, useMemo } from "react";

// // Name of the CSS variables used in tailwind.config.ts
// export interface IThemeVariables {
//   "--color-accent-1": string;
// }

// // Name of the defined colors in the Tailwind theme
// export interface IThemeColors {
//   "accent-1"?: string;
// }

type Props = {
  children: React.ReactNode;
  brand?: BrandInterface;
};

type ThemeContextType = {
  brand?: BrandInterface;
};

const ThemeContext = createContext<ThemeContextType>({
  brand: {} as BrandInterface,
});

export function BrandThemeProvider(props: Props) {

  // Note: if you want switch themes on demand, you should
  // add `props.themeRGB` to the dependency array
  const brandId = props.brand?.id;
  useEffect(() => {
    applyTheme(props.brand);
  }, [brandId]);

  const value: ThemeContextType | undefined = useMemo(() => {
    if (!props.brand) {
      return undefined;
    }
    return { brand: props.brand };
  }, [props.brand]);

  // if (!value) { return null; }

  return <ThemeContext.Provider value={value ?? {}}>{props.children}</ThemeContext.Provider>;
}

function applyTheme(brand?: BrandInterface) {
  if (!brand?.theme) {
    return;
  }
  const theme = { ...DefaultTheme, ...brand.theme };
  const themeObject = mapTheme(theme);
  const root = document.documentElement;

  Object.keys(themeObject).forEach((v) => {
    // const validation = validateRGB(propertyVal);
    // if (!validation) {
    //   throw new Error(`Invalid RGB value for ${v}: ${propertyVal}`);
    // }

    root.style.setProperty(v, themeObject[v] as unknown as any);
  });
}

function mapTheme(theme: BrandThemeInterface): any {
  return {
    "--swivl-headerColor": theme["headerColor"] ?? "",
    "--swivl-headerBackground": theme["headerBackground"] ?? "",
    "--swivl-text": theme["text"] ?? "",
    "--swivl-textBackground": theme["textBackground"] ?? "",
    "--swivl-userBubbleBackground": theme["userBubbleBackground"] ?? "",
    "--swivl-userBubbleText": theme["userBubbleText"] ?? "",
    "--swivl-botBubbleBackground": theme["botBubbleBackground"] ?? "",
    "--swivl-botBubbleText": theme["botBubbleText"] ?? "",
    "--swivl-primaryBackground": theme["primaryBackground"] ?? "",
    "--swivl-primaryText": theme["primaryText"] ?? "",
    "--swivl-primaryHover": theme["primaryHover"] ?? "",
    "--swivl-primaryHoverText": theme["primaryHoverText"] ?? "",
    "--swivl-primaryActive": theme["primaryActive"] ?? "",
    "--swivl-primaryActiveText": theme["primaryActiveText"] ?? "",
    "--swivl-secondaryBackground": theme["secondaryBackground"] ?? "",
    "--swivl-secondaryText": theme["secondaryText"] ?? "",
    "--swivl-secondaryHover": theme["secondaryHover"] ?? "",
    "--swivl-secondaryHoverText": theme["secondaryHoverText"] ?? "",
    "--swivl-secondaryActive": theme["secondaryActive"] ?? "",
    "--swivl-secondaryActiveText": theme["secondaryActiveText"] ?? "",
  };
}
